import {
  Box,
  FormControl,
  FormLabel,
  Typography
} from '@mui/material';
import {
  PhotoUploadField,
  StyledInputTextField,
  appFormUtil
} from 'modules';

import * as types from './types';



export type EditModeSectionProps = {
  form: appFormUtil.InferReturn<types.IFormState>;
};

export const FC = ({ form }: EditModeSectionProps) => {
  const { formState } = form;

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: 1.5,
      minWidth: '460px',
      alignItems: 'stretch'
    }}
    >
      <Typography
        sx={{
        }}
        variant='chartTitle'
      >
        Account Details
      </Typography>

      <Box sx={{
        display: 'flex',
        columnGap: 2
      }}
      >
        <StyledInputTextField.FC
          label='First name'
          {...form.genFieldProps('firstName')}
        />

        <StyledInputTextField.FC
          label='Last name'
          {...form.genFieldProps('lastName')}
        />
      </Box>
      <StyledInputTextField.FC
        label='Email'
        {...form.genFieldProps('preferredEmail')}
      />
      <StyledInputTextField.FC
        label='Phone Number'
        {...form.genFieldProps('phoneNumber')}
      />

      <FormControl>
        <FormLabel>
          <Typography
            variant='formLabel'
          >
            Profile Picture
          </Typography>
        </FormLabel>

        <PhotoUploadField.FC
          file={formState.profilePicture}
          onChange={(file) => form.dispatch({
            type: 'UPDATE',
            payload: {
              property: 'profilePicture',
              value: file
            }
          })}
          onClickDelete={() => form.dispatch({
            type: 'UPDATE',
            payload: {
              property: 'profilePicture',
              value: null
            }
          })}
        />
      </FormControl>
    </Box>
  );
};
